import {useMemo} from 'react';
import type {BrandKitAssetSources} from '@Components/mystuff-brands/brand-kits.types';
import {useAppSelector} from '@/hooks';
import {useBrandContentMap} from '@Hooks/brands/useBrandContentMap';
import {useBrandLogosMap} from '@Hooks/brands/useBrandLogosMap';
import {useBrandColorsMap} from '@Hooks/brands/useBrandColorsMap';
import {useBrandFontsMap} from '@Hooks/brands/useBrandFontsMap';

/** The store-wide asset maps a kit is resolved against, minus the kit itself. Stable while none of the maps change. */
export const useBrandKitAssetSources = (): Omit<BrandKitAssetSources, 'brandKit'> => {
  const brandContent = useBrandContentMap();
  const brandLogosMap = useBrandLogosMap();
  const brandColorsMap = useBrandColorsMap();
  const brandFontsMap = useBrandFontsMap();
  const brandImagesMap = useAppSelector(({brands}) => {
    return brands.images;
  });
  const brandVideosMap = useAppSelector(({brands}) => {
    return brands.videos;
  });
  const brandTemplatesMap = useAppSelector(({brands}) => {
    return brands.templates;
  });

  return useMemo(() => {
    return {brandContent, brandLogosMap, brandColorsMap, brandFontsMap, brandImagesMap, brandVideosMap, brandTemplatesMap};
  }, [brandContent, brandLogosMap, brandColorsMap, brandFontsMap, brandImagesMap, brandVideosMap, brandTemplatesMap]);
};
